import React from 'react';
import RootRouter from "../src/router/RootRouter"

function App() {
  return (
      <RootRouter />
  );
}

export default App;
